module.exports = __webpack_public_path__ + "h5/img/xiang.4d337d08.jpeg";